import { gaTracking, getCurrentPageLocation } from "../../lib/ga";
import type { GANavigationType } from "../../types/ga";

/**
 * Tracks navigation interactions
 * @param navigationChoice - The specific navigation item clicked
 * @param navigationSection - Section of navigation (e.g., main menu category)
 * @param navigationType - Type of navigation UI element
 * @see /GAExamples/navigation.js
 */
export const navigationTracker = (
  navigationChoice: string,
  navigationSection: string,
  navigationType: GANavigationType,
): void => {
  gaTracking({
    event: "navigation",
    event_parameters: {
      page_location: getCurrentPageLocation(),
      navigation_type: navigationType,
      navigation_section: navigationSection,
      navigation_choice: navigationChoice,
    },
  });
};
